
import { CollapseTransition } from 'vue2-transitions'
import Button from '@/components/UntitledUI/Button.vue'

export default {
    name: 'Accordion',

    components: {
        CollapseTransition,
        Button
    },

    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        isActive: {
            required: false,
            type: [Boolean, Number, String],
            default: false
        },
        collapsable: {
            type: Boolean,
            default: true
        },
        duration: {
            type: Number,
            default: 300
        }
    },

    data () {
        return {
            active: this.isActive
        }
    },

    watch: {
        isActive (value) {
            this.active = value
        }
    },

    methods: {
        makeActive () {
            this.active = !this.active

            this.$emit('item-active', this.active)
        }
    }
}
